/**
 * Avalara © 2017
 * file: engines/opus_ui/src/reducers/cases.js
 */

import {
  UPDATE_CASE_REQUEST,
  UPDATE_CASE_SUCCESS,
  UPDATE_CASE_FAILURE,
  FETCH_CASES_SUCCESS,
} from '../actions/cases';

const cases = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_CASE_SUCCESS:
      return {
        ...state,
        ...{
          isCaseUpdating: false,
        },
      };
    case UPDATE_CASE_FAILURE:
      return {
        ...state,
        ...{
          isCaseUpdating: false,
          caseRequestStatus: 'Failed',
        },
      };
    case UPDATE_CASE_REQUEST:
      return {
        ...state,
        ...{
          isCaseUpdating: true,
          caseRequestStatus: '',
        },
      };
    case FETCH_CASES_SUCCESS:
      return {
        ...state,
        ...{
          isCancellationPending: action.cancellationPending,
        },
      };
    default:
      return state;
  }
};

export default cases;
